import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { TextButton, WixIcons } from '../../../../components/common';
import { ModalName } from '../../../../constants/ModalName';
import {
  TrackBoardActionsMenuClickOrigin,
  TrackBoardActionsMenuTarget,
  useTrackBoardAnalytics,
} from '../../../../utils/hooks/bi/useTrackBoardAnalytics';
import { useModalHandlersAndOptions } from '../../../../utils/hooks/useModal';
import { MediaManagerSDKBoard } from '../../../../utils/media-manager-sdk';
import { IOuter } from '../EmptyState.types';

export const AddFilesToBoardButton: FC<IOuter> = ({ currentFolder: board }) => {
  const { openModal: openAddFilesToBoardModal } = useModalHandlersAndOptions(ModalName.AddFilesToBoard);
  const { trackBoardActionsClick } = useTrackBoardAnalytics();

  const handleAddFilesToBoardClick = useCallback(() => {
    openAddFilesToBoardModal({ boards: [board], shouldUpdateItemsInFolder: true });

    trackBoardActionsClick([board as MediaManagerSDKBoard], {
      target: TrackBoardActionsMenuTarget.AddFiles,
      clickOrigin: TrackBoardActionsMenuClickOrigin.EmptyState,
    });
  }, [openAddFilesToBoardModal, board]);

  return (
    <TextButton
      as="a"
      size={window.isNewColorsBrandingEnabled ? 'small' : 'medium'}
      prefixIcon={<WixIcons.Add />}
      onClick={handleAddFilesToBoardClick}
      dataHook="add-items-to-board-empty-state"
    >
      <FormattedMessage id="empty-state.board.add-files" />
    </TextButton>
  );
};
